import { StateObservable } from 'redux-observable';
import { map } from 'rxjs/operators';

import { VariablesEditorDialogAction, State, createFillReservedIds } from '..';
import { Observable } from 'rxjs';
import { EpicDependencies } from '../dependencies.interface';

export const fillReservedIdsFromApi = (
  actions$: Observable<VariablesEditorDialogAction>,
  state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.reservedIds$.pipe(map(createFillReservedIds));
